import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from '@linkdev/shared-library';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
})
export class CookieConsentComponent implements OnInit {
  showPopup: boolean = true; //edit in 22-01-2026 to not show popup by default
  saveCookie: boolean;

  constructor(private translate: TranslateService) {}

  get privacyPolicyUrl(): string {
    const lang = this.translate.currentLang === 'ar' ? 'ar' : 'en';
    return `https://ssa.gov.sa/${lang}/contentTemplate/?path=/privacy-policy/`;
  }

  @Input() config = {
    title: 'Cookies',
    messageText:
      'This site uses cookies to offer you a bettter browsing your experience',
    linkText:"Terms and Conditions, Policies, Privacy Policy.",
    buttonTextOk: 'Allow Cookies',
    buttonTextCancel: 'Decline Cookies'
  };

  ngOnInit(): void {
    let cookieConsented = Helper.getCookieValue('cookieConsented');
    if (cookieConsented) {
      this.showPopup = false;
    }
  }

  public onAllowClick() {
    let expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 12);
    document.cookie = `cookieConsented=true; expires=${expiryDate.toUTCString()};`;
    this.showPopup = false;
    this.saveCookie=true;
  }
    public onDenyClick() {
    let expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 12);
    document.cookie = `cookieConsented=false; expires=${expiryDate.toUTCString()};`;
    this.showPopup = false;
    this.saveCookie=false;

  }
}
